import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { Autocomplete, Box, Stack, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import GlobalDatagrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
import ActionDetails from '../../../../components/mui/GlobalAnchor/ActionDetails';
import GlobalAnchorList from '../../../../components/mui/GlobalAnchor/GlobalAnchorList';
import LeadSingleViewCrm from './LeadSingleViewCrm';
import { useDispatch, useSelector } from 'react-redux';
import CRMAssignation from './CRMAssignation';
import { getCrmLeads } from '../../../../redux/features/crmSlice';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CRM_LEAD_TABLE_HEAD } from '../../../../components/datagrid/CRM/CrmLead/CrmLeadsTableHead';
import { getProjects } from '../../../../redux/features/generalSlice';
import { options } from 'numeral';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';

const CRMLeadsNew = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { crmLeads, loading } = useSelector((state) => state.crm);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { allprojects } = useSelector((state) => state.general);
  const [fromDate, setFromDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('year').format('YYYY-MM-DD'));

  const [value, setValue] = useState(dayjs());

  const [projectID, setProjectID] = useState(null);

  const data = {
    page: pageNum,
    limit: gridSize,
    search: search,
    projectID: projectID,
    date: dayjs(value).format('YYYY-MM'),
    fromDate: fromDate,
    toDate: toDate,
  };

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getCrmLeads(data));
      dispatch(getProjects());
    }
  }, [pageNum, gridSize, value, search, projectID, fromDate, toDate]);

  return (
    <GlobalWrapper title={'CRM Leads'}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'flex-end',
          width: { xs: '100%', lg: '60%', xl: '70%' },
          pb: 1,
          gap: 1,
        }}
      >
        <FromAndToDatePicker
          fromLabel="From Date"
          toLabel="To Date"
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />

        <Autocomplete
          sx={{width:{xs:'100%',lg:'50%'}}}
          name="projectId"
          value={allprojects?.projects?.find((proj) => proj.id === projectID) || null}
          onChange={(event, newValue) => setProjectID(newValue ? newValue.id : null)}
          options={allprojects?.projects || []}
          getOptionLabel={(option) => option.name || ''}
          renderInput={(params) => <TextField fullWidth autoComplete="off" {...params} label="Projects" />}
        />

        {/* <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Year/Month"
              value={value}
              views={['year', 'month']}
              onChange={(newValue) => setValue(newValue)}
              format="YYYY-MM" //
            />
          </LocalizationProvider>
        </Box> */}
      </Box>
      <Box sx={{ width: '100%', padding: 0 }}>
        <GlobalDatagrid
          tableHead={CRM_LEAD_TABLE_HEAD}
          rows={crmLeads.data}
          meta={crmLeads?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="sl_no"
          rowClick={true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.name} />
              {/* <GlobalAnchorList
                component={<LeadSingleViewCrm rowData={rowData} />}
              /> */}

              <GlobalAnchorList label={''} component={<CRMAssignation rowData={rowData} dispatchdata={data} />} />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default CRMLeadsNew;
